import React from "react"
import NonStretchedImage from "../../../Image/non-stretched-image"
import {
  accesDirectItemImg,
  accesDirectItemDescription,
  editButton,
} from "../acces-direct.module.scss"
import PropTypes from "prop-types"
import ProcessedLink from "../../../processed-link"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

const AccesDirectItem = ({ accesDirect }) => {
  let image = ""
  if (
    accesDirect.relationships.image_direct_link.localFile.extension === "svg"
  ) {
    image = (
      <img
        className={accesDirectItemImg}
        src={
          accesDirect.relationships.image_direct_link.localFile
            .SlugifiedPublicUrl
        }
        alt={accesDirect.image_direct_link.alt || ""}
        aria-hidden={true}
      />
    )
  } else if (accesDirect.relationships?.image_direct_link?.localFile) {
    image = (
      <NonStretchedImage
        className={accesDirectItemImg}
        {...accesDirect.relationships.image_direct_link.localFile}
        ariaHidden={true}
      />
    )
  }
  return (
    <>
      <EditButton
        addedClass={editButton}
        link={
          "/admin/structure/direct_link_entity/" +
          accesDirect.drupal_internal__id +
          "/edit"
        }
      />
      <ProcessedLink link={accesDirect.url.uri}>
        {image}
        <h3 className={accesDirectItemDescription}>{accesDirect.name}</h3>
      </ProcessedLink>
    </>
  )
}

AccesDirectItem.propTypes = {
  accesDirect: PropTypes.object.isRequired,
}

export default AccesDirectItem
